/**
 * 108 tin tuyển dụng có nhắc Claude Code, lấy từ app.aitmpl.com/claude-jobs.json
 * (bản chụp 04/08/2026) và ĐÃ KIỂM CHỨNG NGƯỢC ngày 05/08/2026:
 *   - 37/37 tin Anthropic: trang Greenhouse trả 200, tiêu đề khớp tên vị trí
 *   - 67/67 tin HackerNews: khớp nguyên văn bình luận gốc (API Algolia), không tin nào [dead]/[flagged]
 *   - 2/2 RemoteOK sống; 1/2 WeWorkRemotely sống, 1 bị Cloudflare chặn nên không đọc được
 *
 * `tier` là mức độ một dev ở Việt Nam chưa có visa lao động thực sự nộp được:
 *   A = nộp được ngay · B = mở địa lý nhưng đòi senior
 *   C = chặn cứng vì địa lý · D = Anthropic, Staff+ và phải ngồi tại Mỹ/Anh/Úc
 *
 * `kw` là từ khoá phụ tiếng Việt để ô tìm kiếm bỏ dấu tìm được
 * ("sài gòn", "toàn cầu", "từ xa"…) — địa điểm gốc toàn tiếng Anh.
 */
import type { Job } from './types';

export const JOBS: Job[] = [
  {
    "id": "rok-remote-jasper-hot9ja-1135932",
    "company": "Hot9ja",
    "position": "Jasper",
    "location": "Remote",
    "remote": true,
    "salary": "",
    "source": "RemoteOK",
    "url": "https://remoteOK.com/remote-jobs/remote-jasper-hot9ja-1135932",
    "posted": "2026-08-03",
    "ageDays": 2,
    "tier": "A",
    "tags": [
      "Rust"
    ],
    "excerpt": "var userIsAdmin=false; Remote Jasper at Hot9ja { \"@context\": \"http://schema.org\", \"@type\": \"Organization\", \"name\": \"Remote OK\", \"naics\": \"5613\", \"url\": \"https://remoteok.com\", \"logo\": \"https",
    "kw": "từ xa nhóm a nộp được ngay từ xa Rust"
  },
  {
    "id": "rok-remote-genai-engineer-ai-builder-ai-agent-associate-specialist-magic-compass-limited-1135735",
    "company": "Magic Compass Limited",
    "position": "GenAI Engineer AI Builder AI Agent Associate Specialist",
    "location": "Remote",
    "remote": true,
    "salary": "",
    "source": "RemoteOK",
    "url": "https://remoteOK.com/remote-jobs/remote-genai-engineer-ai-builder-ai-agent-associate-specialist-magic-compass-limited-1135735",
    "posted": "2026-07-31",
    "ageDays": 5,
    "tier": "A",
    "tags": [
      "Python",
      "Claude Code",
      "Cursor"
    ],
    "excerpt": "var userIsAdmin=false; Remote Genai Engineer AI Builder AI Agent Associate Specialist (💰~$15k) at Magic Compass Limited { \"@context\": \"http://schema.org\", \"@type\": \"Organization\", \"name\": \"",
    "kw": "từ xa nhóm a nộp được ngay từ xa Python Claude Code Cursor"
  },
  {
    "id": "hn-48754441",
    "company": "Railway",
    "position": "Senior Infra Engineer",
    "location": "REMOTE (Worldwide)",
    "remote": true,
    "salary": "",
    "source": "HackerNews",
    "url": "https://news.ycombinator.com/item?id=48754441",
    "posted": "2026-07-01",
    "ageDays": 34,
    "tier": "A",
    "tags": [
      "AWS"
    ],
    "excerpt": "Railway | Infra Eng-Storage, Infra Eng-Observability, Brand Designer - Web, Infra Eng-General, Product Eng (full-stack) | REMOTE (Worldwide) | https://railway.com/careers Do you feel scared ",
    "kw": "toàn cầu khắp nơi từ xa nhóm a nộp được ngay từ xa AWS"
  },
  {
    "id": "hn-48747990",
    "company": "We The Flywheel",
    "position": "Software Engineer",
    "location": "REMOTE (worldwide)",
    "remote": true,
    "salary": "",
    "source": "HackerNews",
    "url": "https://news.ycombinator.com/item?id=48747990",
    "posted": "2026-07-01",
    "ageDays": 34,
    "tier": "A",
    "tags": [
      "Claude Code",
      "Cursor"
    ],
    "excerpt": "We The Flywheel | AI-Native Engineers & Operators | REMOTE (worldwide) | Contract / Part-time (10–40 hrs/wk) We're a remote-first digital product studio building across sports media, AI, fit",
    "kw": "toàn cầu khắp nơi từ xa nhóm a nộp được ngay từ xa Claude Code Cursor"
  },
  {
    "id": "hn-48416066",
    "company": "vvd",
    "position": "Design Engineer",
    "location": "Remote (work from anywhere)",
    "remote": true,
    "salary": "",
    "source": "HackerNews",
    "url": "https://news.ycombinator.com/item?id=48416066",
    "posted": "2026-06-05",
    "ageDays": 60,
    "tier": "A",
    "tags": [
      "React",
      "Next.js",
      "TypeScript",
      "Go",
      "Claude Code",
      "Cursor"
    ],
    "excerpt": "vvd | Design Engineer | Remote (work from anywhere) | Full-time | React, TypeScript, Next.js https://vvd.world We’re building tools for storytellers, worldbuilders, writers, and creators. We",
    "kw": "toàn cầu khắp nơi từ xa nhóm a nộp được ngay từ xa React Next.js TypeScript Go Claude Code Cursor"
  },
  {
    "id": "hn-48363110",
    "company": "FeedbackPulse",
    "position": "Software Engineer",
    "location": "Remote (SEA-based)",
    "remote": true,
    "salary": "",
    "source": "HackerNews",
    "url": "https://news.ycombinator.com/item?id=48363110",
    "posted": "2026-06-01",
    "ageDays": 64,
    "tier": "A",
    "tags": [],
    "excerpt": "FeedbackPulse | HR/PeopleOps Specialist | Remote (SEA-based) | Full-time | https://feedbackpulse.com Mission: Build better culture & growth systems for companies that don’t have them. Then m",
    "kw": "từ xa đông nam á nhóm a nộp được ngay từ xa"
  },
  {
    "id": "hn-48361035",
    "company": "Railway",
    "position": "Senior Infra Engineer",
    "location": "REMOTE (Worldwide)",
    "remote": true,
    "salary": "",
    "source": "HackerNews",
    "url": "https://news.ycombinator.com/item?id=48361035",
    "posted": "2026-06-01",
    "ageDays": 64,
    "tier": "A",
    "tags": [
      "AWS"
    ],
    "excerpt": "Railway | Infra Eng-Storage, Infra Eng-Observability, Product Design, Infra Eng-General, Product Eng (full-stack) | REMOTE (Worldwide) | https://railway.com/careers Do you feel scared and al",
    "kw": "toàn cầu khắp nơi từ xa nhóm a nộp được ngay từ xa AWS"
  },
  {
    "id": "hn-48357754",
    "company": "Go.Shop",
    "position": "Software Engineer",
    "location": "Remote (GMT to GMT+8, London travel)",
    "remote": true,
    "salary": "",
    "source": "HackerNews",
    "url": "https://news.ycombinator.com/item?id=48357754",
    "posted": "2026-06-01",
    "ageDays": 64,
    "tier": "A",
    "tags": [
      "Next.js",
      "TypeScript",
      "Python",
      "Rust",
      "PostgreSQL",
      "Supabase",
      "Cursor"
    ],
    "excerpt": "Go.Shop | Product Builder — Growth Channels | Remote (GMT to GMT+8, London travel) | REMOTE Go.Shop is the AI-powered platform enabling creators to build and scale consumer product brands — ",
    "kw": "từ xa anh quốc múi giờ việt nam nhóm a nộp được ngay từ xa Next.js TypeScript Python Rust PostgreSQL Supabase Cursor"
  },
  {
    "id": "hn-48062670",
    "company": "We The Flywheel",
    "position": "Software Engineer",
    "location": "Ho Chi Minh City (Hybrid)",
    "remote": false,
    "salary": "",
    "source": "HackerNews",
    "url": "https://news.ycombinator.com/item?id=48062670",
    "posted": "2026-05-08",
    "ageDays": 88,
    "tier": "A",
    "tags": [
      "Claude Code",
      "Cursor"
    ],
    "excerpt": "We The Flywheel | Ho Chi Minh City (Hybrid) | Part-time | https://wetheflywheel.com We are a global media network, digital consultancy, and product studio focused on helping companies grow t",
    "kw": "saigon sài gòn tphcm hcm việt nam tại chỗ nhóm a nộp được ngay tại chỗ Claude Code Cursor"
  },
  {
    "id": "hn-47981963",
    "company": "FeedbackPulse",
    "position": "Software Engineer",
    "location": "Remote (SEA-based)",
    "remote": true,
    "salary": "",
    "source": "HackerNews",
    "url": "https://news.ycombinator.com/item?id=47981963",
    "posted": "2026-05-02",
    "ageDays": 95,
    "tier": "A",
    "tags": [],
    "excerpt": "FeedbackPulse | HR/PeopleOps Specialist | Remote (SEA-based) | Full-time | https://feedbackpulse.com Mission: Build better culture & growth systems for companies that don’t have them. Then m",
    "kw": "từ xa đông nam á nhóm a nộp được ngay từ xa"
  },
  {
    "id": "hn-47978937",
    "company": "Railway",
    "position": "Senior Infra Engineer",
    "location": "REMOTE (Worldwide)",
    "remote": true,
    "salary": "",
    "source": "HackerNews",
    "url": "https://news.ycombinator.com/item?id=47978937",
    "posted": "2026-05-01",
    "ageDays": 95,
    "tier": "A",
    "tags": [
      "AWS"
    ],
    "excerpt": "Railway | Infra Eng-Storage, Infra Eng-Observability, Product Design | REMOTE (Worldwide) | https://railway.com/careers Do you feel scared and alone when opening the AWS console? Do you wish",
    "kw": "toàn cầu khắp nơi từ xa nhóm a nộp được ngay từ xa AWS"
  },
  {
    "id": "hn-47977567",
    "company": "vvd",
    "position": "Design Engineer",
    "location": "Remote (work from anywhere)",
    "remote": true,
    "salary": "",
    "source": "HackerNews",
    "url": "https://news.ycombinator.com/item?id=47977567",
    "posted": "2026-05-01",
    "ageDays": 95,
    "tier": "A",
    "tags": [
      "React",
      "Next.js",
      "TypeScript",
      "Go",
      "Claude Code",
      "Cursor"
    ],
    "excerpt": "vvd | Design Engineer | Remote (work from anywhere) | Full-time | React, TypeScript, Next.js https://vvd.world We’re building tools for storytellers, worldbuilders, writers, and creators. We",
    "kw": "toàn cầu khắp nơi từ xa nhóm a nộp được ngay từ xa React Next.js TypeScript Go Claude Code Cursor"
  },
  {
    "id": "hn-49157129",
    "company": "Checkly",
    "position": "Senior Sales Engineer",
    "location": "Remote (Europe / US Eastern Time zone)",
    "remote": true,
    "salary": "",
    "source": "HackerNews",
    "url": "https://news.ycombinator.com/item?id=49157129",
    "posted": "2026-08-03",
    "ageDays": 1,
    "tier": "B",
    "tags": [
      "Node.js",
      "Claude Code"
    ],
    "excerpt": "Checkly | Senior Sales Engineer, Sales Engineer | Remote (Europe / US Eastern Time zone) | Full-time | https://checklyhq.com Checkly is the active reliability layer for developers and agents",
    "kw": "từ xa mỹ hoa kỳ châu âu nhóm b senior từ xa Node.js Claude Code"
  },
  {
    "id": "hn-49156702",
    "company": "Flywheel Motion ( )",
    "position": "Software Engineer",
    "location": "REMOTE (worldwide)",
    "remote": true,
    "salary": "",
    "source": "HackerNews",
    "url": "https://news.ycombinator.com/item?id=49156702",
    "posted": "2026-08-03",
    "ageDays": 1,
    "tier": "B",
    "tags": [
      "TypeScript",
      "Claude Code",
      "Cursor"
    ],
    "excerpt": "Flywheel Motion ( https://flywheelmotion.com/?utm_source=hackernews ) | REMOTE (worldwide) | Contract We build authority infrastructure for people whose expertise has outgrown their digital ",
    "kw": "toàn cầu khắp nơi từ xa nhóm b senior từ xa TypeScript Claude Code Cursor"
  },
  {
    "id": "hn-48915735",
    "company": "Portless",
    "position": "AI Engineer",
    "location": "Remote (North America)",
    "remote": true,
    "salary": "$180k-$230k",
    "source": "HackerNews",
    "url": "https://news.ycombinator.com/item?id=48915735",
    "posted": "2026-07-15",
    "ageDays": 21,
    "tier": "B",
    "tags": [
      "TypeScript",
      "Python",
      "Claude Code",
      "Cursor",
      "Copilot"
    ],
    "excerpt": "Portless | AI Engineer | Remote (North America) | $180k-$230k | Full-time We're a company doing real operational work in e-commerce/3PL logistics. AI usage internally is still basic — decks,",
    "kw": "từ xa mỹ hoa kỳ nhóm b senior từ xa có lương TypeScript Python Claude Code Cursor Copilot"
  },
  {
    "id": "hn-48900749",
    "company": "Namecoach/Euphonia",
    "position": "AI Engineer",
    "location": "SF or Remote",
    "remote": true,
    "salary": "",
    "source": "HackerNews",
    "url": "https://news.ycombinator.com/item?id=48900749",
    "posted": "2026-07-14",
    "ageDays": 22,
    "tier": "B",
    "tags": [
      "Claude Code",
      "Cursor"
    ],
    "excerpt": "Namecoach/Euphonia | Founding Voice AI Engineer (part-time, path to CAIO) | SF or Remote | REMOTE | Contract / Part-time, ~$30-120/hr by seniority, potentially converting to FT Namecoach has",
    "kw": "từ xa nhóm b senior từ xa Claude Code Cursor"
  },
  {
    "id": "hn-48819370",
    "company": "Rabbet (YC S17)",
    "position": "Software Engineer",
    "location": "REMOTE (TX, NC, CO)",
    "remote": true,
    "salary": "",
    "source": "HackerNews",
    "url": "https://news.ycombinator.com/item?id=48819370",
    "posted": "2026-07-07",
    "ageDays": 28,
    "tier": "B",
    "tags": [
      "React",
      "PostgreSQL",
      "AWS",
      "GCP"
    ],
    "excerpt": "Rabbet (YC S17) | Sr. Software Engineer (Elixir/React) | REMOTE (TX, NC, CO) | Full time Rabbet is hiring Sr. Software Engineers to help us streamline construction finances. We offer cloud-b",
    "kw": "từ xa nhóm b senior từ xa React PostgreSQL AWS GCP"
  },
  {
    "id": "wwr-vidalytics-ai-automation-engineer-in-house-martech-video-saas",
    "company": "Vidalytics",
    "position": "AI Automation Engineer, In-House MarTech Video SaaS",
    "location": "Remote",
    "remote": true,
    "salary": "",
    "source": "WeWorkRemotely",
    "url": "https://weworkremotely.com/remote-jobs/vidalytics-ai-automation-engineer-in-house-martech-video-saas",
    "posted": "2026-07-07",
    "ageDays": 28,
    "tier": "B",
    "tags": [
      "Rust",
      "Go",
      "GCP",
      "Claude Code",
      "Rails"
    ],
    "excerpt": "Headquarters: Austin, TX URL: https://vidalytics.com If you love building AI agents, wiring systems together, and watching whole teams stop doing by hand what a machine can do better, faster",
    "kw": "từ xa nhóm b senior từ xa Rust Go GCP Claude Code Rails"
  },
  {
    "id": "wwr-vidalytics-europe-only-gtm-martech-engineer-growth-attribution-at-video-martech-saas",
    "company": "Vidalytics",
    "position": "[EUROPE ONLY] GTM MarTech Engineer (Growth & Attribution) at Video MarTech SaaS",
    "location": "Remote",
    "remote": true,
    "salary": "",
    "source": "WeWorkRemotely",
    "url": "https://weworkremotely.com/remote-jobs/vidalytics-europe-only-gtm-martech-engineer-growth-attribution-at-video-martech-saas",
    "posted": "2026-07-07",
    "ageDays": 28,
    "tier": "B",
    "tags": [
      "React",
      "JavaScript",
      "Rust",
      "Go",
      "Node.js",
      "GCP",
      "Claude Code",
      "MySQL"
    ],
    "excerpt": "window.NREUM||(NREUM={});NREUM.info={\"beacon\":\"bam.nr-data.net\",\"errorBeacon\":\"bam.nr-data.net\",\"licenseKey\":\"f7ae79e7ca\",\"applicationID\":\"192262830\",\"transactionName\":\"d1gPFhEMXVVWQxwMDVZET",
    "kw": "từ xa châu âu nhóm b senior từ xa React JavaScript Rust Go Node.js GCP Claude Code MySQL"
  },
  {
    "id": "hn-48768318",
    "company": "airCFO ( )",
    "position": "Software Engineer",
    "location": "Remote, UTC -8 - UTC +2",
    "remote": true,
    "salary": "",
    "source": "HackerNews",
    "url": "https://news.ycombinator.com/item?id=48768318",
    "posted": "2026-07-02",
    "ageDays": 33,
    "tier": "B",
    "tags": [
      "React",
      "TypeScript",
      "Python",
      "PostgreSQL"
    ],
    "excerpt": "airCFO ( https://aircfo.com ) | Founding Engineer | Remote, UTC -8 - UTC +2 | Full-time, part-time possible for the right candidate airCFO is an AI-powered accounting & finance services part",
    "kw": "từ xa nhóm b senior từ xa React TypeScript Python PostgreSQL"
  },
  {
    "id": "hn-48756639",
    "company": "Dashdoc",
    "position": "Software Engineer",
    "location": "REMOTE / EU",
    "remote": true,
    "salary": "€50k–€80k",
    "source": "HackerNews",
    "url": "https://news.ycombinator.com/item?id=48756639",
    "posted": "2026-07-02",
    "ageDays": 34,
    "tier": "B",
    "tags": [
      "React",
      "Python",
      "Go",
      "PostgreSQL",
      "GCP",
      "Claude Code",
      "Cursor",
      "React Native",
      "Django"
    ],
    "excerpt": "Dashdoc | Product/Software Engineer, BeNeLux Expansion | Dutch-speaking | REMOTE / EU | Full-time | €50k–€80k | React, React Native, Python/Django, PostgreSQL, GCP Dashdoc is a SaaS Transpor",
    "kw": "từ xa châu âu nhóm b senior từ xa có lương React Python Go PostgreSQL GCP Claude Code Cursor React Native Django"
  },
  {
    "id": "hn-48751913",
    "company": "ALBERT",
    "position": "Software Engineer",
    "location": "REMOTE ALMOST ANYWHERE IN THE WORLD",
    "remote": true,
    "salary": "$750k",
    "source": "HackerNews",
    "url": "https://news.ycombinator.com/item?id=48751913",
    "posted": "2026-07-01",
    "ageDays": 34,
    "tier": "B",
    "tags": [
      "React",
      "Python",
      "Rust",
      "PostgreSQL",
      "React Native"
    ],
    "excerpt": "ALBERT | REMOTE ALMOST ANYWHERE IN THE WORLD| Hiring principal and distinguished engineers to build net new products | up to ~ $750k Hiring: exceptional consumer product engineers at Albert.",
    "kw": "toàn cầu khắp nơi từ xa nhóm b senior từ xa có lương React Python Rust PostgreSQL React Native"
  },
  {
    "id": "hn-48750050",
    "company": "ArtCraft",
    "position": "Backend Engineer",
    "location": "Remote (Global) / Onsite (SF Bay Area and Atlanta, Georgia)",
    "remote": true,
    "salary": "",
    "source": "HackerNews",
    "url": "https://news.ycombinator.com/item?id=48750050",
    "posted": "2026-07-01",
    "ageDays": 34,
    "tier": "B",
    "tags": [
      "Rust",
      "Go",
      "Claude Code",
      "MySQL"
    ],
    "excerpt": "ArtCraft | Backend Engineer (Rust, MySQL) | Remote (Global) / Onsite (SF Bay Area and Atlanta, Georgia) | https://github.com/storytold/artcraft | https://getartcraft.com We’re experienced ar",
    "kw": "từ xa tại chỗ nhóm b senior từ xa Rust Go Claude Code MySQL"
  },
  {
    "id": "hn-48749788",
    "company": "Delta AI",
    "position": "Software Engineer",
    "location": "ONSITE SF Bay Area (Remote)",
    "remote": true,
    "salary": "",
    "source": "HackerNews",
    "url": "https://news.ycombinator.com/item?id=48749788",
    "posted": "2026-07-01",
    "ageDays": 34,
    "tier": "B",
    "tags": [
      "React",
      "TypeScript",
      "Node.js",
      "Claude Code"
    ],
    "excerpt": "Delta AI | Full Stack / AI Founding Engineer | ONSITE SF Bay Area | $120-140k + 1-1.5% equity + benefits (flexible on comp) Delta AI is building an AI-powered, scenario-based training platfo",
    "kw": "từ xa tại chỗ nhóm b senior từ xa React TypeScript Node.js Claude Code"
  },
  {
    "id": "hn-48748512",
    "company": "Credo Health",
    "position": "Full Stack Engineer",
    "location": "NYC (HYBRID — 1 day/week onsite, otherwise remote)",
    "remote": true,
    "salary": "$125k–$175k",
    "source": "HackerNews",
    "url": "https://news.ycombinator.com/item?id=48748512",
    "posted": "2026-07-01",
    "ageDays": 34,
    "tier": "B",
    "tags": [
      "Python",
      "PostgreSQL",
      "Cursor",
      "Copilot",
      "Django",
      "Vue.js"
    ],
    "excerpt": "Credo Health | Full Stack Engineer | NYC (HYBRID — 1 day/week onsite, otherwise remote) | $125k–$175k + equity | Full-time I'm Ketan, Head of Engineering at Credo. We're a seed-stage, HIPAA-",
    "kw": "từ xa tại chỗ nhóm b senior từ xa có lương Python PostgreSQL Cursor Copilot Django Vue.js"
  },
  {
    "id": "hn-48377948",
    "company": "ALBERT",
    "position": "Software Engineer",
    "location": "REMOTE ALMOST ANYWHERE IN THE WORLD",
    "remote": true,
    "salary": "$750k",
    "source": "HackerNews",
    "url": "https://news.ycombinator.com/item?id=48377948",
    "posted": "2026-06-03",
    "ageDays": 63,
    "tier": "B",
    "tags": [
      "React",
      "Python",
      "Rust",
      "PostgreSQL",
      "React Native"
    ],
    "excerpt": "ALBERT | REMOTE ALMOST ANYWHERE IN THE WORLD| Hiring principal and distinguished engineers to build net new products | up to ~ $750k Hiring: exceptional consumer product engineers at Albert.",
    "kw": "toàn cầu khắp nơi từ xa nhóm b senior từ xa có lương React Python Rust PostgreSQL React Native"
  },
  {
    "id": "hn-48368468",
    "company": "RealEstateU",
    "position": "Software Engineer",
    "location": "REMOTE (UTC-01:00 to UTC+03:00)",
    "remote": true,
    "salary": "",
    "source": "HackerNews",
    "url": "https://news.ycombinator.com/item?id=48368468",
    "posted": "2026-06-02",
    "ageDays": 64,
    "tier": "B",
    "tags": [
      "React",
      "Azure",
      "Claude Code",
      "Cursor",
      "MongoDB"
    ],
    "excerpt": "RealEstateU | Fullstack Engineer, MERN / LMS | REMOTE (UTC-01:00 to UTC+03:00) | Contract, full-time We're a leading online U.S. real estate education provider. Our custom LMS is a large MER",
    "kw": "từ xa châu âu nhóm b senior từ xa React Azure Claude Code Cursor MongoDB"
  },
  {
    "id": "hn-48358657",
    "company": "*Scribd",
    "position": "Lead Product Manager",
    "location": "REMOTE*",
    "remote": true,
    "salary": "",
    "source": "HackerNews",
    "url": "https://news.ycombinator.com/item?id=48358657",
    "posted": "2026-06-01",
    "ageDays": 64,
    "tier": "B",
    "tags": [
      "TypeScript",
      "Python",
      "AWS",
      "Claude Code",
      "Ruby",
      "Rails"
    ],
    "excerpt": "*Scribd | Lead Product Manager, AI Developer Platform | US, Canada | REMOTE* Scribd, Inc. is on a mission to advance human understanding. Our four products — Scribd®, Slideshare®, Everand™, ",
    "kw": "từ xa nhóm b senior từ xa TypeScript Python AWS Claude Code Ruby Rails"
  },
  {
    "id": "hn-48358336",
    "company": "Kepler",
    "position": "Full Stack Engineer",
    "location": "New York, NY (Remote)",
    "remote": true,
    "salary": "$230K-$260K",
    "source": "HackerNews",
    "url": "https://news.ycombinator.com/item?id=48358336",
    "posted": "2026-06-01",
    "ageDays": 64,
    "tier": "B",
    "tags": [
      "React",
      "TypeScript",
      "Rust",
      "PostgreSQL",
      "AWS"
    ],
    "excerpt": "Kepler | Full Stack Engineer | New York, NY | ONSITE | $230K-$260K + equity We're building the trust layer for AI in high-stakes industries. https://kepler.ai LLMs hallucinate, so they can't",
    "kw": "từ xa mỹ hoa kỳ nhóm b senior từ xa có lương React TypeScript Rust PostgreSQL AWS"
  },
  {
    "id": "hn-48102189",
    "company": "Revieve",
    "position": "Product Engineer",
    "location": "Remote (Helsinki HQ)",
    "remote": true,
    "salary": "",
    "source": "HackerNews",
    "url": "https://news.ycombinator.com/item?id=48102189",
    "posted": "2026-05-11",
    "ageDays": 85,
    "tier": "B",
    "tags": [
      "React",
      "TypeScript",
      "Claude Code"
    ],
    "excerpt": "Revieve | Product Engineer | Remote (Helsinki HQ) | Full-time | Contractor/Vendor Revieve builds AI-powered personalization for 120+ beauty brands across 40+ countries — think skin analysis,",
    "kw": "từ xa châu âu nhóm b senior từ xa React TypeScript Claude Code"
  },
  {
    "id": "hn-48059654",
    "company": "HME Technologies",
    "position": "Software Engineer",
    "location": "Full-Time (Remote)",
    "remote": true,
    "salary": "$40k-$75k",
    "source": "HackerNews",
    "url": "https://news.ycombinator.com/item?id=48059654",
    "posted": "2026-05-08",
    "ageDays": 89,
    "tier": "B",
    "tags": [
      "JavaScript",
      "Python"
    ],
    "excerpt": "HME Technologies | AI Operations Lead | REMOTE | Full-Time | $40k-$75k base + Bonus HME Technologies ( https://hmetech.com/ ) is a small, profitable media and affiliate marketing company. We",
    "kw": "từ xa nhóm b senior từ xa có lương JavaScript Python"
  },
  {
    "id": "hn-48000122",
    "company": "TrakPro",
    "position": "Senior Rails Engineer",
    "location": "REMOTE (overlap with Ireland 9–5 GMT)",
    "remote": true,
    "salary": "€48–60k",
    "source": "HackerNews",
    "url": "https://news.ycombinator.com/item?id=48000122",
    "posted": "2026-05-03",
    "ageDays": 93,
    "tier": "B",
    "tags": [
      "PostgreSQL",
      "AWS",
      "Claude Code",
      "Rails"
    ],
    "excerpt": "TrakPro | Senior Rails Engineer | REMOTE (overlap with Ireland 9–5 GMT) | €48–60k/yr We're a construction payment management SaaS based in Ireland. Main contractors and subcontractors use us",
    "kw": "từ xa châu âu nhóm b senior từ xa có lương PostgreSQL AWS Claude Code Rails"
  },
  {
    "id": "hn-47999884",
    "company": "Kepler",
    "position": "Full Stack Engineer",
    "location": "New York, NY (Remote)",
    "remote": true,
    "salary": "$230K-$260K",
    "source": "HackerNews",
    "url": "https://news.ycombinator.com/item?id=47999884",
    "posted": "2026-05-03",
    "ageDays": 93,
    "tier": "B",
    "tags": [
      "React",
      "TypeScript",
      "Rust",
      "PostgreSQL",
      "AWS"
    ],
    "excerpt": "Kepler | Full Stack Engineer | New York, NY | ONSITE | $230K-$260K + equity We're building the trust layer for AI in high-stakes industries. https://kepler.ai LLMs hallucinate, so they can't",
    "kw": "từ xa mỹ hoa kỳ nhóm b senior từ xa có lương React TypeScript Rust PostgreSQL AWS"
  },
  {
    "id": "hn-47975833",
    "company": "Deep Core Technology",
    "position": "Software Engineer",
    "location": "REMOTE (CANADA)",
    "remote": true,
    "salary": "$105,000 - $125,000",
    "source": "HackerNews",
    "url": "https://news.ycombinator.com/item?id=47975833",
    "posted": "2026-05-01",
    "ageDays": 95,
    "tier": "B",
    "tags": [
      "Next.js",
      "TypeScript",
      "Python",
      "Supabase",
      "Claude Code"
    ],
    "excerpt": "Deep Core Technology | Founding Engineer | REMOTE (CANADA) | Full Time | Salary: $105,000 - $125,000 CAD + 1% equity Company: We’re building a geologic modelling software, based on reasoning",
    "kw": "từ xa canada nhóm b senior từ xa có lương Next.js TypeScript Python Supabase Claude Code"
  },
  {
    "id": "hn-47975788",
    "company": "Normcore.io",
    "position": "Software Engineer",
    "location": "Remote PT/ET Hours",
    "remote": true,
    "salary": "",
    "source": "HackerNews",
    "url": "https://news.ycombinator.com/item?id=47975788",
    "posted": "2026-05-01",
    "ageDays": 95,
    "tier": "B",
    "tags": [
      "Go",
      "Claude Code"
    ],
    "excerpt": "Normcore.io | Head of Strategic Finance | Full-time | $100-140K USD | Remote PT/ET Hours I'm the founder of Normcore.io, an autoscaling game server hosting service and Unity plugin that incl",
    "kw": "từ xa nhóm b senior từ xa Go Claude Code"
  },
  {
    "id": "hn-49163658",
    "company": "pganalyze",
    "position": "Software Engineer",
    "location": "REMOTE (US)",
    "remote": true,
    "salary": "",
    "source": "HackerNews",
    "url": "https://news.ycombinator.com/item?id=49163658",
    "posted": "2026-08-04",
    "ageDays": 1,
    "tier": "C",
    "tags": [
      "PostgreSQL",
      "Claude Code"
    ],
    "excerpt": "pganalyze | Marketing Manager | REMOTE (US) | Full-time | base $130-160k + annual bonus + equity | https://pganalyze.com At pganalyze, we build observability and automation tools for optimiz",
    "kw": "từ xa mỹ hoa kỳ nhóm c chặn địa lý từ xa PostgreSQL Claude Code"
  },
  {
    "id": "hn-48833943",
    "company": "Catalyst·Wayfare AI",
    "position": "Lead AI Engineer",
    "location": "Remote (US)",
    "remote": true,
    "salary": "",
    "source": "HackerNews",
    "url": "https://news.ycombinator.com/item?id=48833943",
    "posted": "2026-07-08",
    "ageDays": 27,
    "tier": "C",
    "tags": [
      "Python",
      "AWS",
      "GCP",
      "Claude Code"
    ],
    "excerpt": "Catalyst·Wayfare AI | Lead AI Engineer + Agent Builders | Remote (US) | Full-time + Contract | https://www.catalystwayfare.ai/careers We build and ship production AI systems for mid-market e",
    "kw": "từ xa mỹ hoa kỳ nhóm c chặn địa lý từ xa Python AWS GCP Claude Code"
  },
  {
    "id": "hn-48823535",
    "company": "Youth Inc.",
    "position": "Senior Software Engineer",
    "location": "On-site",
    "remote": false,
    "salary": "$120k–$190k",
    "source": "HackerNews",
    "url": "https://news.ycombinator.com/item?id=48823535",
    "posted": "2026-07-07",
    "ageDays": 28,
    "tier": "C",
    "tags": [
      "Next.js",
      "Rust",
      "PostgreSQL",
      "AWS",
      "Claude Code"
    ],
    "excerpt": "Youth Inc. ( https://youth.inc ) is hiring a Senior Software Engineer (Hybrid: Boston/Chicago). We’re a venture-backed e-commerce marketplace and media network for youth and high school spor",
    "kw": "tại chỗ nhóm c chặn địa lý tại chỗ có lương Next.js Rust PostgreSQL AWS Claude Code"
  },
  {
    "id": "hn-48811937",
    "company": "Cora AI",
    "position": "AI Engineer",
    "location": "REMOTE (US ONLY, LA/SF preferred)",
    "remote": true,
    "salary": "",
    "source": "HackerNews",
    "url": "https://news.ycombinator.com/item?id=48811937",
    "posted": "2026-07-06",
    "ageDays": 29,
    "tier": "C",
    "tags": [
      "Go",
      "Claude Code",
      "Cursor"
    ],
    "excerpt": "Cora AI | Founding Full Stack / Applied AI Engineer | REMOTE (US ONLY, LA/SF preferred) | Full-time | $190–250k + early equity We build customer success agents and account intelligence that ",
    "kw": "từ xa mỹ hoa kỳ nhóm c chặn địa lý từ xa Go Claude Code Cursor"
  },
  {
    "id": "hn-48801745",
    "company": "Electric Twin",
    "position": "Product Engineer",
    "location": "London, UK",
    "remote": false,
    "salary": "",
    "source": "HackerNews",
    "url": "https://news.ycombinator.com/item?id=48801745",
    "posted": "2026-07-06",
    "ageDays": 30,
    "tier": "C",
    "tags": [
      "React",
      "Next.js",
      "Python",
      "GCP",
      "Cursor"
    ],
    "excerpt": "Electric Twin | London, UK | Full-time | Hybrid (4 days/week in office) Electric Twin builds science-based synthetic populations — LLM-driven AI agents that simulate human behaviour, so comp",
    "kw": "anh quốc nhóm c chặn địa lý tại chỗ React Next.js Python GCP Cursor"
  },
  {
    "id": "hn-48766112",
    "company": "We are hiring full",
    "position": "Software Engineer",
    "location": "On-site",
    "remote": false,
    "salary": "",
    "source": "HackerNews",
    "url": "https://news.ycombinator.com/item?id=48766112",
    "posted": "2026-07-02",
    "ageDays": 33,
    "tier": "C",
    "tags": [],
    "excerpt": "We are hiring full-stack and applied AI engineers, as well as a UI designer, for in-person roles in NYC. Our product helps everyone make better legal decisions by better understanding the la",
    "kw": "tại chỗ nhóm c chặn địa lý tại chỗ"
  },
  {
    "id": "hn-48761457",
    "company": "Runway",
    "position": "Trust & Safety Engineer",
    "location": "London / NYC / SF / Seattle / Remote (US + Europe)",
    "remote": true,
    "salary": "",
    "source": "HackerNews",
    "url": "https://news.ycombinator.com/item?id=48761457",
    "posted": "2026-07-02",
    "ageDays": 33,
    "tier": "C",
    "tags": [
      "TypeScript",
      "Python",
      "Rust",
      "AWS",
      "GCP"
    ],
    "excerpt": "Runway | Trust & Safety Engineer | London / NYC / SF / Seattle / Remote (US + Europe) | Full-time We're hiring a Trust & Safety Engineer to join Runway's AI Safety and Responsibility team. R",
    "kw": "từ xa mỹ hoa kỳ anh quốc châu âu nhóm c chặn địa lý từ xa TypeScript Python Rust AWS GCP"
  },
  {
    "id": "hn-48754933",
    "company": "Connie Health",
    "position": "Senior Analytics Engineer",
    "location": "Boston, MA",
    "remote": false,
    "salary": "$150k-$185k",
    "source": "HackerNews",
    "url": "https://news.ycombinator.com/item?id=48754933",
    "posted": "2026-07-02",
    "ageDays": 34,
    "tier": "C",
    "tags": [
      "Rust",
      "PostgreSQL"
    ],
    "excerpt": "Connie Health | Senior Analytics Engineer | Boston, MA | HYBRID | $150k-$185k + equity Connie Health is a fast-growing Medicare brokerage on a mission to empower older Americans to make conf",
    "kw": "mỹ hoa kỳ nhóm c chặn địa lý tại chỗ có lương Rust PostgreSQL"
  },
  {
    "id": "hn-48754582",
    "company": "Obsidian Security",
    "position": "Staff Software Engineer",
    "location": "Philadelphia or Palo Alto",
    "remote": false,
    "salary": "$176k-$196k",
    "source": "HackerNews",
    "url": "https://news.ycombinator.com/item?id=48754582",
    "posted": "2026-07-01",
    "ageDays": 34,
    "tier": "C",
    "tags": [
      "React",
      "TypeScript",
      "Python",
      "Rust",
      "PostgreSQL"
    ],
    "excerpt": "Obsidian Security | Staff Software Engineer | Philadelphia or Palo Alto | Full-time | $176k-$196k + equity + 401k | https://job-boards.greenhouse.io/obsidiansecurity/jobs/51527... We secure ",
    "kw": "mỹ hoa kỳ nhóm c chặn địa lý tại chỗ có lương React TypeScript Python Rust PostgreSQL"
  },
  {
    "id": "hn-48750836",
    "company": "Grafana Labs",
    "position": "Staff Software Engineer",
    "location": "100% Remote (US + Canada)",
    "remote": true,
    "salary": "",
    "source": "HackerNews",
    "url": "https://news.ycombinator.com/item?id=48750836",
    "posted": "2026-07-01",
    "ageDays": 34,
    "tier": "C",
    "tags": [
      "Claude Code",
      "Cursor"
    ],
    "excerpt": "Grafana Labs | Senior/Staff Software Engineer - AI / Agentic apps | 100% Remote (US + Canada) | Im the hiring manager - some of the product highlights under the team's scope: - Grafana Assis",
    "kw": "từ xa mỹ hoa kỳ canada nhóm c chặn địa lý từ xa Claude Code Cursor"
  },
  {
    "id": "hn-48749072",
    "company": "DoubleVerify (DV Scibids)",
    "position": "Software Engineer",
    "location": "ONSITE/HYBRID - New York, NY (3x/week)",
    "remote": false,
    "salary": "$89K–$178K",
    "source": "HackerNews",
    "url": "https://news.ycombinator.com/item?id=48749072",
    "posted": "2026-07-01",
    "ageDays": 34,
    "tier": "C",
    "tags": [
      "Python",
      "Rust",
      "GCP",
      "Docker",
      "Claude Code",
      "Cursor",
      "Java"
    ],
    "excerpt": "DoubleVerify (DV Scibids) | Sr. Data Engineer I | ONSITE/HYBRID - New York, NY (3x/week) | Full-time | $89K–$178K DV Scibids is the AI-powered digital campaign activation arm of DoubleVerify",
    "kw": "tại chỗ mỹ hoa kỳ nhóm c chặn địa lý tại chỗ có lương Python Rust GCP Docker Claude Code Cursor Java"
  },
  {
    "id": "hn-48505744",
    "company": "Wrenly",
    "position": "Software Engineer",
    "location": "REMOTE (Brazil-based only)",
    "remote": true,
    "salary": "",
    "source": "HackerNews",
    "url": "https://news.ycombinator.com/item?id=48505744",
    "posted": "2026-06-12",
    "ageDays": 53,
    "tier": "C",
    "tags": [
      "Go"
    ],
    "excerpt": "Wrenly | Founding Customer Success Manager (AI-first) | REMOTE (Brazil-based only) | Full-time contract via Deel, USD base + commission | https://www.wrenly.ai/hiring/csm Wrenly is a bootstr",
    "kw": "từ xa brazil nhóm c chặn địa lý từ xa Go"
  },
  {
    "id": "hn-48426455",
    "company": "Comvex",
    "position": "Platform Engineer",
    "location": "REMOTE (US, South America)",
    "remote": true,
    "salary": "140K-160K",
    "source": "HackerNews",
    "url": "https://news.ycombinator.com/item?id=48426455",
    "posted": "2026-06-06",
    "ageDays": 59,
    "tier": "C",
    "tags": [
      "React",
      "Python",
      "Go",
      "AWS",
      "Django"
    ],
    "excerpt": "Comvex | Full Time | Multiple Roles | REMOTE (US, South America) We're a healthcare revenue cycle management (RCM) technology company looking for our first set of full hires to help us build",
    "kw": "từ xa mỹ hoa kỳ nhóm c chặn địa lý từ xa có lương React Python Go AWS Django"
  },
  {
    "id": "hn-48404934",
    "company": "We are hiring full",
    "position": "Software Engineer",
    "location": "On-site",
    "remote": false,
    "salary": "",
    "source": "HackerNews",
    "url": "https://news.ycombinator.com/item?id=48404934",
    "posted": "2026-06-04",
    "ageDays": 61,
    "tier": "C",
    "tags": [],
    "excerpt": "We are hiring full-stack and applied AI engineers, as well as a UI designer, for in-person roles in NYC. Our product helps everyone make better legal decisions by better understanding the la",
    "kw": "tại chỗ nhóm c chặn địa lý tại chỗ"
  },
  {
    "id": "hn-48403016",
    "company": "Second Nature",
    "position": "Staff Software Engineer",
    "location": "REMOTE (US)",
    "remote": true,
    "salary": "$150K-$180K",
    "source": "HackerNews",
    "url": "https://news.ycombinator.com/item?id=48403016",
    "posted": "2026-06-04",
    "ageDays": 61,
    "tier": "C",
    "tags": [
      "React",
      "Next.js",
      "TypeScript",
      "Python",
      "PostgreSQL",
      "AWS",
      "Kubernetes",
      "Claude Code"
    ],
    "excerpt": "Second Nature | Staff Software Engineer (Engineering AI Team), Staff Software Engineer, Senior Software Engineer, Engineering Manager | REMOTE (US) | Full-time Second Nature ( https://second",
    "kw": "từ xa mỹ hoa kỳ nhóm c chặn địa lý từ xa có lương React Next.js TypeScript Python PostgreSQL AWS Kubernetes Claude Code"
  },
  {
    "id": "hn-48389925",
    "company": "Deep Core Technology",
    "position": "Software Engineer",
    "location": "REMOTE (MUST LIVE IN CANADA)",
    "remote": true,
    "salary": "$105,000 - $125,000",
    "source": "HackerNews",
    "url": "https://news.ycombinator.com/item?id=48389925",
    "posted": "2026-06-03",
    "ageDays": 62,
    "tier": "C",
    "tags": [
      "Next.js",
      "TypeScript",
      "Python",
      "Supabase",
      "Claude Code"
    ],
    "excerpt": "Deep Core Technology | Founding Engineer | REMOTE (MUST LIVE IN CANADA) | Full Time | Salary: $105,000 - $125,000 CAD + equity Company: We’re building a geologic modelling software, based on",
    "kw": "từ xa canada nhóm c chặn địa lý từ xa có lương Next.js TypeScript Python Supabase Claude Code"
  },
  {
    "id": "hn-48385146",
    "company": "Catalyst·Wayfare AI",
    "position": "Lead AI Engineer",
    "location": "Remote (US)",
    "remote": true,
    "salary": "",
    "source": "HackerNews",
    "url": "https://news.ycombinator.com/item?id=48385146",
    "posted": "2026-06-03",
    "ageDays": 62,
    "tier": "C",
    "tags": [
      "Python",
      "Rust",
      "Claude Code",
      "Cursor"
    ],
    "excerpt": "Catalyst·Wayfare AI | Lead AI Engineer + Agent Builder + Platform Engineer | Remote (US) | Full-time / Part-time / Contract | https://catalystwayfare.ai/careers AI transformation firm shippi",
    "kw": "từ xa mỹ hoa kỳ nhóm c chặn địa lý từ xa Python Rust Claude Code Cursor"
  },
  {
    "id": "hn-48383195",
    "company": "Neuralk AI",
    "position": "Software Engineer",
    "location": "Full-time",
    "remote": false,
    "salary": "",
    "source": "HackerNews",
    "url": "https://news.ycombinator.com/item?id=48383195",
    "posted": "2026-06-03",
    "ageDays": 62,
    "tier": "C",
    "tags": [
      "Python"
    ],
    "excerpt": "Neuralk AI | Field Engineer | Full-time | Hybrid (Paris/London) We are a seed stage startup building Tabular Foundation Models (TFM). This is an emerging space with huge potential. LLM's lik",
    "kw": "nhóm c chặn địa lý tại chỗ Python"
  },
  {
    "id": "hn-48373447",
    "company": "Santa Clara, CA",
    "position": "Software Engineer",
    "location": "Jefit",
    "remote": false,
    "salary": "$115K-$125K",
    "source": "HackerNews",
    "url": "https://news.ycombinator.com/item?id=48373447",
    "posted": "2026-06-02",
    "ageDays": 63,
    "tier": "C",
    "tags": [
      "Claude Code",
      "Cursor",
      "Copilot",
      "Kotlin"
    ],
    "excerpt": "Santa Clara, CA | ONSITE | Android Engineer (AI-native, junior-friendly) | Jefit | $115K-$125K + equity + benefits Jefit is a profitable fitness-tech company — 15+ years in market, no fundin",
    "kw": "mỹ hoa kỳ nhóm c chặn địa lý tại chỗ có lương Claude Code Cursor Copilot Kotlin"
  },
  {
    "id": "hn-48372101",
    "company": "AES (associatedenvironmentalsystems.com)",
    "position": "Software Engineer",
    "location": "REMOTE (US, with occasional Boston-area days)",
    "remote": true,
    "salary": "",
    "source": "HackerNews",
    "url": "https://news.ycombinator.com/item?id=48372101",
    "posted": "2026-06-02",
    "ageDays": 63,
    "tier": "C",
    "tags": [
      "Next.js",
      "TypeScript",
      "PostgreSQL",
      "Claude Code",
      "Tailwind"
    ],
    "excerpt": "AES (associatedenvironmentalsystems.com) | Summer Software Engineering Intern | REMOTE (US, with occasional Boston-area days) | $30-40/hr | Full or part-time | June 15 – Aug 22, 2026 \"The se",
    "kw": "từ xa mỹ hoa kỳ nhóm c chặn địa lý từ xa Next.js TypeScript PostgreSQL Claude Code Tailwind"
  },
  {
    "id": "hn-48366911",
    "company": "TrashLab",
    "position": "Software Engineer",
    "location": "Full-time SF Hybrid",
    "remote": false,
    "salary": "",
    "source": "HackerNews",
    "url": "https://news.ycombinator.com/item?id=48366911",
    "posted": "2026-06-02",
    "ageDays": 64,
    "tier": "C",
    "tags": [
      "Claude Code"
    ],
    "excerpt": "TrashLab | Product, Eng | Full-time SF Hybrid We are building the agentic operating system for waste collection and processing companies across the US. Join our team as a product manager or ",
    "kw": "tại chỗ nhóm c chặn địa lý tại chỗ Claude Code"
  },
  {
    "id": "hn-48365092",
    "company": "Opaxa",
    "position": "Full-Stack Engineer",
    "location": "San Francisco",
    "remote": false,
    "salary": "$200K–$300K",
    "source": "HackerNews",
    "url": "https://news.ycombinator.com/item?id=48365092",
    "posted": "2026-06-02",
    "ageDays": 64,
    "tier": "C",
    "tags": [
      "React",
      "TypeScript",
      "Python",
      "PostgreSQL",
      "Claude Code",
      "Cursor"
    ],
    "excerpt": "Opaxa | Founding Full-Stack Engineer | San Francisco | Full-time | $200K–$300K + founding equity | opaxa.ai Opaxa is the AI agent platform that runs restaurant back-office operations. Not an",
    "kw": "mỹ hoa kỳ nhóm c chặn địa lý tại chỗ có lương React TypeScript Python PostgreSQL Claude Code Cursor"
  },
  {
    "id": "hn-48361997",
    "company": "Veedma",
    "position": "Product Engineer",
    "location": "Remote (US)",
    "remote": true,
    "salary": "",
    "source": "HackerNews",
    "url": "https://news.ycombinator.com/item?id=48361997",
    "posted": "2026-06-01",
    "ageDays": 64,
    "tier": "C",
    "tags": [
      "Python",
      "PostgreSQL",
      "Claude Code",
      "Flask"
    ],
    "excerpt": "Veedma | Founding Product Engineer + Founding Growth Engineer | Remote (US) | Full-time | $150-200k + 1.0-1.25% equity | https://app.dover.com/jobs/veedma Veedma is a telehealth practice for",
    "kw": "từ xa mỹ hoa kỳ nhóm c chặn địa lý từ xa Python PostgreSQL Claude Code Flask"
  },
  {
    "id": "hn-48361574",
    "company": "Obsidian Security",
    "position": "Staff Software Engineer",
    "location": "REMOTE (US)",
    "remote": true,
    "salary": "$176k-$196k",
    "source": "HackerNews",
    "url": "https://news.ycombinator.com/item?id=48361574",
    "posted": "2026-06-01",
    "ageDays": 64,
    "tier": "C",
    "tags": [
      "React",
      "TypeScript",
      "Python",
      "Rust",
      "PostgreSQL"
    ],
    "excerpt": "Obsidian Security | Staff Software Engineer | REMOTE (US) | Full-time | $176k-$196k + equity + 401k | https://job-boards.greenhouse.io/obsidiansecurity/jobs/51527... We secure the SaaS apps ",
    "kw": "từ xa mỹ hoa kỳ nhóm c chặn địa lý từ xa có lương React TypeScript Python Rust PostgreSQL"
  },
  {
    "id": "hn-48359608",
    "company": "JustPark",
    "position": "Lead Full Stack Engineer",
    "location": "London (Hybrid) & Dallas (Hybrid)",
    "remote": false,
    "salary": "",
    "source": "HackerNews",
    "url": "https://news.ycombinator.com/item?id=48359608",
    "posted": "2026-06-01",
    "ageDays": 64,
    "tier": "C",
    "tags": [
      "React",
      "TypeScript",
      "Python",
      "AWS",
      "GCP",
      "Claude Code",
      "React Native",
      "Django"
    ],
    "excerpt": "JustPark | Lead Engineers | London (Hybrid) & Dallas (Hybrid) | Full-time JustPark is a parking platform serving millions of drivers and operators across the UK and US. We're hiring two lead",
    "kw": "tại chỗ anh quốc nhóm c chặn địa lý tại chỗ React TypeScript Python AWS GCP Claude Code React Native Django"
  },
  {
    "id": "hn-48358775",
    "company": "Emergences Labs (emergences.ai)",
    "position": "Software Engineer",
    "location": "REMOTE (US)",
    "remote": true,
    "salary": "$120K-$150K",
    "source": "HackerNews",
    "url": "https://news.ycombinator.com/item?id=48358775",
    "posted": "2026-06-01",
    "ageDays": 64,
    "tier": "C",
    "tags": [
      "React",
      "Next.js",
      "TypeScript",
      "Node.js",
      "PostgreSQL",
      "Supabase",
      "Claude Code",
      "Cursor"
    ],
    "excerpt": "Emergences Labs (emergences.ai) | AI / Systems Engineer — NeoHuman | REMOTE (US) | Full-time | $120K-$150K + equity | Visa sponsorship available We're a small, research-driven, VC-backed tea",
    "kw": "từ xa mỹ hoa kỳ nhóm c chặn địa lý từ xa có lương React Next.js TypeScript Node.js PostgreSQL Supabase Claude Code Cursor"
  },
  {
    "id": "hn-48358702",
    "company": "Authorium",
    "position": "Senior Full-Stack Engineer",
    "location": "San Francisco, CA",
    "remote": false,
    "salary": "$148k-230k",
    "source": "HackerNews",
    "url": "https://news.ycombinator.com/item?id=48358702",
    "posted": "2026-06-01",
    "ageDays": 64,
    "tier": "C",
    "tags": [
      "Next.js",
      "Claude Code",
      "Ruby",
      "Rails"
    ],
    "excerpt": "Authorium | Full-Stack Engineer (Mid & Senior) | San Francisco, CA | ONSITE (Mon-Thu hybrid) | Full-time | $148k-230k + equity | https://authorium.com We're building the operating system for",
    "kw": "mỹ hoa kỳ nhóm c chặn địa lý tại chỗ có lương Next.js Claude Code Ruby Rails"
  },
  {
    "id": "hn-48358370",
    "company": "Cora AI",
    "position": "AI Engineer",
    "location": "REMOTE (US ONLY, LA/SF preferred)",
    "remote": true,
    "salary": "",
    "source": "HackerNews",
    "url": "https://news.ycombinator.com/item?id=48358370",
    "posted": "2026-06-01",
    "ageDays": 64,
    "tier": "C",
    "tags": [
      "Go",
      "Claude Code",
      "Cursor"
    ],
    "excerpt": "Cora AI | Founding Full Stack / Applied AI Engineer | REMOTE (US ONLY, LA/SF preferred) | Full-time | $190–250k + early equity We build customer success agents and account intelligence that ",
    "kw": "từ xa mỹ hoa kỳ nhóm c chặn địa lý từ xa Go Claude Code Cursor"
  },
  {
    "id": "hn-48012401",
    "company": "Waypoint Learning (EdTech)",
    "position": "Software Engineer",
    "location": "NYC or Remote (US)",
    "remote": true,
    "salary": "",
    "source": "HackerNews",
    "url": "https://news.ycombinator.com/item?id=48012401",
    "posted": "2026-05-04",
    "ageDays": 92,
    "tier": "C",
    "tags": [
      "TypeScript",
      "Python"
    ],
    "excerpt": "Waypoint Learning (EdTech) | Founding Engineer | NYC or Remote (US) | Full-time Students with disabilities are not receiving the support they deserve, and Waypoint is changing that. We're bu",
    "kw": "từ xa mỹ hoa kỳ nhóm c chặn địa lý từ xa TypeScript Python"
  },
  {
    "id": "hn-48011307",
    "company": "AirOps",
    "position": "Software Engineer",
    "location": "SF · NYC · Montevideo",
    "remote": false,
    "salary": "",
    "source": "HackerNews",
    "url": "https://news.ycombinator.com/item?id=48011307",
    "posted": "2026-05-04",
    "ageDays": 92,
    "tier": "C",
    "tags": [
      "Python"
    ],
    "excerpt": "AirOps | Engineering, GTM | SF · NYC · Montevideo Search is being rewritten — buyers ask ChatGPT, Claude, and Perplexity, and the brands cited in those answers win. AirOps is the runtime mar",
    "kw": "nhóm c chặn địa lý tại chỗ Python"
  },
  {
    "id": "hn-48005277",
    "company": "Deepline",
    "position": "Software Engineer",
    "location": "On-site",
    "remote": false,
    "salary": "$160k–$220k",
    "source": "HackerNews",
    "url": "https://news.ycombinator.com/item?id=48005277",
    "posted": "2026-05-04",
    "ageDays": 93,
    "tier": "C",
    "tags": [
      "Next.js",
      "TypeScript",
      "Python",
      "PostgreSQL",
      "Claude Code"
    ],
    "excerpt": "Deepline | NYC (ONSITE) | Founding Full-stack Engineers and Forward Deployed Engineers | $160k–$220k + meaningful equity User interfaces are dead. Knowledge workers will exclusively work thr",
    "kw": "tại chỗ nhóm c chặn địa lý tại chỗ có lương Next.js TypeScript Python PostgreSQL Claude Code"
  },
  {
    "id": "hn-47985407",
    "company": "Axis Communications",
    "position": "Software Engineer",
    "location": "Linköping, Sweden (Onsite)",
    "remote": false,
    "salary": "",
    "source": "HackerNews",
    "url": "https://news.ycombinator.com/item?id=47985407",
    "posted": "2026-05-02",
    "ageDays": 95,
    "tier": "C",
    "tags": [
      "TypeScript",
      "Rust",
      "Claude Code",
      "Copilot"
    ],
    "excerpt": "Axis Communications | Software Engineer - Video Management & Agentic Engineering | Linköping, Sweden (Onsite) Join a newly formed R&D team at Axis focused on rethinking how software is built",
    "kw": "tại chỗ châu âu nhóm c chặn địa lý tại chỗ TypeScript Rust Claude Code Copilot"
  },
  {
    "id": "hn-47982567",
    "company": "MintMCP",
    "position": "Software Engineer",
    "location": "SF Bay Area (ONSITE)",
    "remote": false,
    "salary": "",
    "source": "HackerNews",
    "url": "https://news.ycombinator.com/item?id=47982567",
    "posted": "2026-05-02",
    "ageDays": 95,
    "tier": "C",
    "tags": [
      "Claude Code"
    ],
    "excerpt": "MintMCP | Founding Engineer / Founding GTM | SF Bay Area (ONSITE) MintMCP helps enterprises safely roll out agents to the entire organization (e.g, governance around MCP tools and agents lik",
    "kw": "tại chỗ nhóm c chặn địa lý tại chỗ Claude Code"
  },
  {
    "id": "hn-47980891",
    "company": "Startup working on AI Healthcare solutions",
    "position": "Software Engineer",
    "location": "REMOTE(US, Pacific time zone)",
    "remote": true,
    "salary": "",
    "source": "HackerNews",
    "url": "https://news.ycombinator.com/item?id=47980891",
    "posted": "2026-05-01",
    "ageDays": 95,
    "tier": "C",
    "tags": [
      "Python",
      "Claude Code"
    ],
    "excerpt": "Startup working on AI Healthcare solutions (plus some random experiments) | REMOTE(US, Pacific time zone) | Full time and project based Full time engineering role (Remote, US person required",
    "kw": "từ xa mỹ hoa kỳ nhóm c chặn địa lý từ xa Python Claude Code"
  },
  {
    "id": "hn-47977662",
    "company": "Form AI",
    "position": "AI Engineer",
    "location": "REMOTE (US) / Austin",
    "remote": true,
    "salary": "$150k-$220k",
    "source": "HackerNews",
    "url": "https://news.ycombinator.com/item?id=47977662",
    "posted": "2026-05-01",
    "ageDays": 95,
    "tier": "C",
    "tags": [
      "React",
      "Next.js",
      "TypeScript",
      "Python"
    ],
    "excerpt": "Form AI | Full-Stack AI Engineer (Contract) | REMOTE (US) / Austin | https://formai.build Form is an AI fluency/integration startup for executives & their teams. We build AI applications tai",
    "kw": "từ xa mỹ hoa kỳ nhóm c chặn địa lý từ xa có lương React Next.js TypeScript Python"
  },
  {
    "id": "hn-47976768",
    "company": "Opendate",
    "position": "Senior Full Stack Engineer",
    "location": "REMOTE (US only)",
    "remote": true,
    "salary": "",
    "source": "HackerNews",
    "url": "https://news.ycombinator.com/item?id=47976768",
    "posted": "2026-05-01",
    "ageDays": 95,
    "tier": "C",
    "tags": [
      "React",
      "Go",
      "PostgreSQL",
      "AWS",
      "GCP",
      "Docker",
      "Claude Code",
      "Cursor",
      "Copilot",
      "Ruby"
    ],
    "excerpt": "Opendate | Senior Full Stack Engineer (Ruby on Rails) | REMOTE (US only) | Full-time | https://www.opendate.io/careers/senior-full-stack-software-e... Opendate is the operating system for li",
    "kw": "từ xa mỹ hoa kỳ nhóm c chặn địa lý từ xa React Go PostgreSQL AWS GCP Docker Claude Code Cursor Copilot Ruby"
  },
  {
    "id": "anth-5251866008",
    "company": "Anthropic",
    "position": "Product Manager, Claude Code",
    "location": "San Francisco, CA | New York City, NY",
    "remote": false,
    "salary": "",
    "source": "Anthropic",
    "url": "https://job-boards.greenhouse.io/anthropic/jobs/5251866008",
    "posted": "2026-08-03",
    "ageDays": 1,
    "tier": "D",
    "tags": [
      "Rust",
      "AWS",
      "Claude Code",
      "Anthropic"
    ],
    "excerpt": "About Anthropic Anthropic’s mission is to create reliable, interpretable, and steerable AI systems. We want AI to be safe and beneficial for our users and for society as a whole. Our team is",
    "kw": "mỹ hoa kỳ nhóm d anthropic tại chỗ Rust AWS Claude Code Anthropic"
  },
  {
    "id": "anth-5355526008",
    "company": "Anthropic",
    "position": "Finance Systems Engineer, Revenue",
    "location": "San Francisco, CA | Seattle, WA",
    "remote": false,
    "salary": "",
    "source": "Anthropic",
    "url": "https://job-boards.greenhouse.io/anthropic/jobs/5355526008",
    "posted": "2026-07-16",
    "ageDays": 19,
    "tier": "D",
    "tags": [
      "React",
      "JavaScript",
      "Python",
      "Rust",
      "Node.js",
      "PostgreSQL",
      "AWS",
      "Claude Code",
      "Java",
      "Anthropic"
    ],
    "excerpt": "About Anthropic Anthropic’s mission is to create reliable, interpretable, and steerable AI systems. We want AI to be safe and beneficial for our users and for society as a whole. Our team is",
    "kw": "mỹ hoa kỳ nhóm d anthropic tại chỗ React JavaScript Python Rust Node.js PostgreSQL AWS Claude Code Java Anthropic"
  },
  {
    "id": "anth-5342935008",
    "company": "Anthropic",
    "position": "Staff+ Software Engineer, Safeguards Review Tooling",
    "location": "San Francisco, CA",
    "remote": false,
    "salary": "",
    "source": "Anthropic",
    "url": "https://job-boards.greenhouse.io/anthropic/jobs/5342935008",
    "posted": "2026-07-13",
    "ageDays": 22,
    "tier": "D",
    "tags": [
      "Rust",
      "AWS",
      "Claude Code",
      "Rails",
      "Anthropic"
    ],
    "excerpt": "About Anthropic Anthropic’s mission is to create reliable, interpretable, and steerable AI systems. We want AI to be safe and beneficial for our users and for society as a whole. Our team is",
    "kw": "mỹ hoa kỳ nhóm d anthropic tại chỗ Rust AWS Claude Code Rails Anthropic"
  },
  {
    "id": "anth-5311465008",
    "company": "Anthropic",
    "position": "Technical Enablement Lead, Claude Platform",
    "location": "San Francisco, CA | New York City, NY | Seattle, WA",
    "remote": false,
    "salary": "",
    "source": "Anthropic",
    "url": "https://job-boards.greenhouse.io/anthropic/jobs/5311465008",
    "posted": "2026-07-10",
    "ageDays": 25,
    "tier": "D",
    "tags": [
      "Rust",
      "AWS",
      "Claude Code",
      "Anthropic"
    ],
    "excerpt": "About Anthropic Anthropic’s mission is to create reliable, interpretable, and steerable AI systems. We want AI to be safe and beneficial for our users and for society as a whole. Our team is",
    "kw": "mỹ hoa kỳ nhóm d anthropic tại chỗ Rust AWS Claude Code Anthropic"
  },
  {
    "id": "anth-5309805008",
    "company": "Anthropic",
    "position": "Engineering Manager, Connectivity - London",
    "location": "London, UK",
    "remote": false,
    "salary": "",
    "source": "Anthropic",
    "url": "https://job-boards.greenhouse.io/anthropic/jobs/5309805008",
    "posted": "2026-07-09",
    "ageDays": 26,
    "tier": "D",
    "tags": [
      "TypeScript",
      "Python",
      "Rust",
      "AWS",
      "Claude Code",
      "Anthropic"
    ],
    "excerpt": "About Anthropic Anthropic’s mission is to create reliable, interpretable, and steerable AI systems. We want AI to be safe and beneficial for our users and for society as a whole. Our team is",
    "kw": "anh quốc nhóm d anthropic tại chỗ TypeScript Python Rust AWS Claude Code Anthropic"
  },
  {
    "id": "anth-5304425008",
    "company": "Anthropic",
    "position": "Staff Software Engineer, Labs: Applied AI",
    "location": "San Francisco, CA | New York City, NY",
    "remote": false,
    "salary": "",
    "source": "Anthropic",
    "url": "https://job-boards.greenhouse.io/anthropic/jobs/5304425008",
    "posted": "2026-07-08",
    "ageDays": 27,
    "tier": "D",
    "tags": [
      "Rust",
      "AWS",
      "Claude Code",
      "Anthropic"
    ],
    "excerpt": "About Anthropic Anthropic’s mission is to create reliable, interpretable, and steerable AI systems. We want AI to be safe and beneficial for our users and for society as a whole. Our team is",
    "kw": "mỹ hoa kỳ nhóm d anthropic tại chỗ Rust AWS Claude Code Anthropic"
  },
  {
    "id": "anth-5288742008",
    "company": "Anthropic",
    "position": "Staff+ Software Engineer, Enterprise",
    "location": "San Francisco, CA | New York City, NY",
    "remote": false,
    "salary": "",
    "source": "Anthropic",
    "url": "https://job-boards.greenhouse.io/anthropic/jobs/5288742008",
    "posted": "2026-07-01",
    "ageDays": 34,
    "tier": "D",
    "tags": [
      "Python",
      "Rust",
      "Go",
      "PostgreSQL",
      "AWS",
      "GCP",
      "Azure",
      "Kubernetes",
      "Claude Code",
      "Anthropic"
    ],
    "excerpt": "About Anthropic Anthropic’s mission is to create reliable, interpretable, and steerable AI systems. We want AI to be safe and beneficial for our users and for society as a whole. Our team is",
    "kw": "mỹ hoa kỳ nhóm d anthropic tại chỗ Python Rust Go PostgreSQL AWS GCP Azure Kubernetes Claude Code Anthropic"
  },
  {
    "id": "anth-5198999008",
    "company": "Anthropic",
    "position": "Technical Specialist, Claude Code",
    "location": "London, UK",
    "remote": false,
    "salary": "",
    "source": "Anthropic",
    "url": "https://job-boards.greenhouse.io/anthropic/jobs/5198999008",
    "posted": "2026-06-25",
    "ageDays": 41,
    "tier": "D",
    "tags": [
      "Rust",
      "Go",
      "AWS",
      "Claude Code",
      "Anthropic"
    ],
    "excerpt": "About Anthropic Anthropic’s mission is to create reliable, interpretable, and steerable AI systems. We want AI to be safe and beneficial for our users and for society as a whole. Our team is",
    "kw": "anh quốc nhóm d anthropic tại chỗ Rust Go AWS Claude Code Anthropic"
  },
  {
    "id": "anth-5277834008",
    "company": "Anthropic",
    "position": "Manager, Applied AI Engineering, Beneficial Deployments (Life Sciences)",
    "location": "San Francisco, CA | New York City, NY",
    "remote": false,
    "salary": "",
    "source": "Anthropic",
    "url": "https://job-boards.greenhouse.io/anthropic/jobs/5277834008",
    "posted": "2026-06-24",
    "ageDays": 41,
    "tier": "D",
    "tags": [
      "Rust",
      "AWS",
      "Claude Code",
      "Anthropic"
    ],
    "excerpt": "About Anthropic Anthropic’s mission is to create reliable, interpretable, and steerable AI systems. We want AI to be safe and beneficial for our users and for society as a whole. Our team is",
    "kw": "mỹ hoa kỳ nhóm d anthropic tại chỗ Rust AWS Claude Code Anthropic"
  },
  {
    "id": "anth-5271428008",
    "company": "Anthropic",
    "position": "Staff Software Engineer, Developer Productivity (CI/CD) - Claude Code",
    "location": "San Francisco, CA",
    "remote": false,
    "salary": "",
    "source": "Anthropic",
    "url": "https://job-boards.greenhouse.io/anthropic/jobs/5271428008",
    "posted": "2026-06-18",
    "ageDays": 47,
    "tier": "D",
    "tags": [
      "Python",
      "Rust",
      "Go",
      "AWS",
      "Kubernetes",
      "Claude Code",
      "Anthropic"
    ],
    "excerpt": "About Anthropic Anthropic’s mission is to create reliable, interpretable, and steerable AI systems. We want AI to be safe and beneficial for our users and for society as a whole. Our team is",
    "kw": "mỹ hoa kỳ nhóm d anthropic tại chỗ Python Rust Go AWS Kubernetes Claude Code Anthropic"
  },
  {
    "id": "anth-5271426008",
    "company": "Anthropic",
    "position": "Staff Software Engineer, Developer Productivity (Dev Environments) - Claude Code",
    "location": "San Francisco, CA",
    "remote": false,
    "salary": "",
    "source": "Anthropic",
    "url": "https://job-boards.greenhouse.io/anthropic/jobs/5271426008",
    "posted": "2026-06-18",
    "ageDays": 47,
    "tier": "D",
    "tags": [
      "Python",
      "Rust",
      "Go",
      "AWS",
      "Docker",
      "Kubernetes",
      "Claude Code",
      "Anthropic"
    ],
    "excerpt": "About Anthropic Anthropic’s mission is to create reliable, interpretable, and steerable AI systems. We want AI to be safe and beneficial for our users and for society as a whole. Our team is",
    "kw": "mỹ hoa kỳ nhóm d anthropic tại chỗ Python Rust Go AWS Docker Kubernetes Claude Code Anthropic"
  },
  {
    "id": "anth-5255912008",
    "company": "Anthropic",
    "position": "Engineering Manager, Enterprise",
    "location": "San Francisco, CA | New York City, NY",
    "remote": false,
    "salary": "",
    "source": "Anthropic",
    "url": "https://job-boards.greenhouse.io/anthropic/jobs/5255912008",
    "posted": "2026-06-12",
    "ageDays": 53,
    "tier": "D",
    "tags": [
      "Rust",
      "AWS",
      "Claude Code",
      "Anthropic"
    ],
    "excerpt": "About Anthropic Anthropic’s mission is to create reliable, interpretable, and steerable AI systems. We want AI to be safe and beneficial for our users and for society as a whole. Our team is",
    "kw": "mỹ hoa kỳ nhóm d anthropic tại chỗ Rust AWS Claude Code Anthropic"
  },
  {
    "id": "anth-5251609008",
    "company": "Anthropic",
    "position": "Technical Program Manager, Apps Platform",
    "location": "San Francisco, CA | Seattle, WA",
    "remote": false,
    "salary": "",
    "source": "Anthropic",
    "url": "https://job-boards.greenhouse.io/anthropic/jobs/5251609008",
    "posted": "2026-06-09",
    "ageDays": 57,
    "tier": "D",
    "tags": [
      "Rust",
      "AWS",
      "Claude Code",
      "Anthropic"
    ],
    "excerpt": "About Anthropic Anthropic’s mission is to create reliable, interpretable, and steerable AI systems. We want AI to be safe and beneficial for our users and for society as a whole. Our team is",
    "kw": "mỹ hoa kỳ nhóm d anthropic tại chỗ Rust AWS Claude Code Anthropic"
  },
  {
    "id": "anth-5247640008",
    "company": "Anthropic",
    "position": "Product Manager, Claude Code Model Performance",
    "location": "San Francisco, CA | Seattle, WA",
    "remote": false,
    "salary": "",
    "source": "Anthropic",
    "url": "https://job-boards.greenhouse.io/anthropic/jobs/5247640008",
    "posted": "2026-06-04",
    "ageDays": 61,
    "tier": "D",
    "tags": [
      "Rust",
      "AWS",
      "Claude Code",
      "Anthropic"
    ],
    "excerpt": "About Anthropic Anthropic’s mission is to create reliable, interpretable, and steerable AI systems. We want AI to be safe and beneficial for our users and for society as a whole. Our team is",
    "kw": "mỹ hoa kỳ nhóm d anthropic tại chỗ Rust AWS Claude Code Anthropic"
  },
  {
    "id": "anth-5229345008",
    "company": "Anthropic",
    "position": "Staff Software Engineer, Claude Design",
    "location": "San Francisco, CA | New York City, NY | Seattle, WA",
    "remote": false,
    "salary": "",
    "source": "Anthropic",
    "url": "https://job-boards.greenhouse.io/anthropic/jobs/5229345008",
    "posted": "2026-05-27",
    "ageDays": 69,
    "tier": "D",
    "tags": [
      "React",
      "TypeScript",
      "Python",
      "Rust",
      "Node.js",
      "AWS",
      "Claude Code",
      "Anthropic"
    ],
    "excerpt": "About Anthropic Anthropic’s mission is to create reliable, interpretable, and steerable AI systems. We want AI to be safe and beneficial for our users and for society as a whole. Our team is",
    "kw": "mỹ hoa kỳ nhóm d anthropic tại chỗ React TypeScript Python Rust Node.js AWS Claude Code Anthropic"
  },
  {
    "id": "anth-5228463008",
    "company": "Anthropic",
    "position": "Support Engineer",
    "location": "San Francisco, CA | New York City, NY | Seattle, WA",
    "remote": false,
    "salary": "",
    "source": "Anthropic",
    "url": "https://job-boards.greenhouse.io/anthropic/jobs/5228463008",
    "posted": "2026-05-22",
    "ageDays": 74,
    "tier": "D",
    "tags": [
      "JavaScript",
      "Python",
      "Rust",
      "AWS",
      "GCP",
      "Claude Code",
      "Anthropic"
    ],
    "excerpt": "About Anthropic Anthropic’s mission is to create reliable, interpretable, and steerable AI systems. We want AI to be safe and beneficial for our users and for society as a whole. Our team is",
    "kw": "mỹ hoa kỳ nhóm d anthropic tại chỗ JavaScript Python Rust AWS GCP Claude Code Anthropic"
  },
  {
    "id": "anth-5222289008",
    "company": "Anthropic",
    "position": "Manager of Applied AI Architecture, Enterprise Tech",
    "location": "San Francisco, CA | New York City, NY",
    "remote": false,
    "salary": "",
    "source": "Anthropic",
    "url": "https://job-boards.greenhouse.io/anthropic/jobs/5222289008",
    "posted": "2026-05-18",
    "ageDays": 78,
    "tier": "D",
    "tags": [
      "Rust",
      "Go",
      "AWS",
      "Claude Code",
      "Anthropic"
    ],
    "excerpt": "About Anthropic Anthropic’s mission is to create reliable, interpretable, and steerable AI systems. We want AI to be safe and beneficial for our users and for society as a whole. Our team is",
    "kw": "mỹ hoa kỳ nhóm d anthropic tại chỗ Rust Go AWS Claude Code Anthropic"
  },
  {
    "id": "anth-5197538008",
    "company": "Anthropic",
    "position": "Manager of Applied AI Architecture, Enterprise Tech (Cyber)",
    "location": "New York City, NY; San Francisco, CA | New York City, NY; Seattle, WA",
    "remote": false,
    "salary": "",
    "source": "Anthropic",
    "url": "https://job-boards.greenhouse.io/anthropic/jobs/5197538008",
    "posted": "2026-04-24",
    "ageDays": 102,
    "tier": "D",
    "tags": [
      "Rust",
      "AWS",
      "Claude Code",
      "Anthropic"
    ],
    "excerpt": "About Anthropic Anthropic’s mission is to create reliable, interpretable, and steerable AI systems. We want AI to be safe and beneficial for our users and for society as a whole. Our team is",
    "kw": "mỹ hoa kỳ nhóm d anthropic tại chỗ Rust AWS Claude Code Anthropic"
  },
  {
    "id": "anth-5184077008",
    "company": "Anthropic",
    "position": "Head of ANZ, Applied AI",
    "location": "Sydney, Australia",
    "remote": false,
    "salary": "",
    "source": "Anthropic",
    "url": "https://job-boards.greenhouse.io/anthropic/jobs/5184077008",
    "posted": "2026-04-24",
    "ageDays": 102,
    "tier": "D",
    "tags": [
      "Rust",
      "AWS",
      "Claude Code",
      "Anthropic"
    ],
    "excerpt": "About Anthropic Anthropic’s mission is to create reliable, interpretable, and steerable AI systems. We want AI to be safe and beneficial for our users and for society as a whole. Our team is",
    "kw": "úc nhóm d anthropic tại chỗ Rust AWS Claude Code Anthropic"
  },
  {
    "id": "anth-5192805008",
    "company": "Anthropic",
    "position": "Applied AI Architect, Commercial",
    "location": "San Francisco, CA | New York City, NY",
    "remote": false,
    "salary": "",
    "source": "Anthropic",
    "url": "https://job-boards.greenhouse.io/anthropic/jobs/5192805008",
    "posted": "2026-04-17",
    "ageDays": 109,
    "tier": "D",
    "tags": [
      "Python",
      "Rust",
      "Go",
      "AWS",
      "Claude Code",
      "Anthropic"
    ],
    "excerpt": "About Anthropic Anthropic’s mission is to create reliable, interpretable, and steerable AI systems. We want AI to be safe and beneficial for our users and for society as a whole. Our team is",
    "kw": "mỹ hoa kỳ nhóm d anthropic tại chỗ Python Rust Go AWS Claude Code Anthropic"
  },
  {
    "id": "anth-5192104008",
    "company": "Anthropic",
    "position": "Head of Applied AI Architecture, Beneficial Deployments",
    "location": "San Francisco, CA | New York City, NY",
    "remote": false,
    "salary": "",
    "source": "Anthropic",
    "url": "https://job-boards.greenhouse.io/anthropic/jobs/5192104008",
    "posted": "2026-04-17",
    "ageDays": 109,
    "tier": "D",
    "tags": [
      "Python",
      "Rust",
      "AWS",
      "Claude Code",
      "Anthropic"
    ],
    "excerpt": "About Anthropic Anthropic’s mission is to create reliable, interpretable, and steerable AI systems. We want AI to be safe and beneficial for our users and for society as a whole. Our team is",
    "kw": "mỹ hoa kỳ nhóm d anthropic tại chỗ Python Rust AWS Claude Code Anthropic"
  },
  {
    "id": "anth-5174743008",
    "company": "Anthropic",
    "position": "Senior Software Engineer, Full-stack",
    "location": "San Francisco, CA | New York City, NY | Seattle, WA",
    "remote": false,
    "salary": "",
    "source": "Anthropic",
    "url": "https://job-boards.greenhouse.io/anthropic/jobs/5174743008",
    "posted": "2026-04-08",
    "ageDays": 118,
    "tier": "D",
    "tags": [
      "React",
      "TypeScript",
      "Rust",
      "AWS",
      "Claude Code",
      "Anthropic"
    ],
    "excerpt": "About Anthropic Anthropic’s mission is to create reliable, interpretable, and steerable AI systems. We want AI to be safe and beneficial for our users and for society as a whole. Our team is",
    "kw": "mỹ hoa kỳ nhóm d anthropic tại chỗ React TypeScript Rust AWS Claude Code Anthropic"
  },
  {
    "id": "anth-5174747008",
    "company": "Anthropic",
    "position": "Staff+ Software Engineer, Full-stack",
    "location": "San Francisco, CA | New York City, NY | Seattle, WA",
    "remote": false,
    "salary": "",
    "source": "Anthropic",
    "url": "https://job-boards.greenhouse.io/anthropic/jobs/5174747008",
    "posted": "2026-04-08",
    "ageDays": 118,
    "tier": "D",
    "tags": [
      "React",
      "TypeScript",
      "Rust",
      "AWS",
      "Claude Code",
      "Anthropic"
    ],
    "excerpt": "About Anthropic Anthropic’s mission is to create reliable, interpretable, and steerable AI systems. We want AI to be safe and beneficial for our users and for society as a whole. Our team is",
    "kw": "mỹ hoa kỳ nhóm d anthropic tại chỗ React TypeScript Rust AWS Claude Code Anthropic"
  },
  {
    "id": "anth-5174755008",
    "company": "Anthropic",
    "position": "Staff+ Software Engineer, Backend",
    "location": "San Francisco, CA | New York City, NY | Seattle, WA",
    "remote": false,
    "salary": "",
    "source": "Anthropic",
    "url": "https://job-boards.greenhouse.io/anthropic/jobs/5174755008",
    "posted": "2026-04-08",
    "ageDays": 118,
    "tier": "D",
    "tags": [
      "Rust",
      "AWS",
      "Claude Code",
      "Anthropic"
    ],
    "excerpt": "About Anthropic Anthropic’s mission is to create reliable, interpretable, and steerable AI systems. We want AI to be safe and beneficial for our users and for society as a whole. Our team is",
    "kw": "mỹ hoa kỳ nhóm d anthropic tại chỗ Rust AWS Claude Code Anthropic"
  },
  {
    "id": "anth-5157847008",
    "company": "Anthropic",
    "position": "Staff+ Software Engineer, Platform",
    "location": "San Francisco, CA | New York City, NY | Seattle, WA",
    "remote": false,
    "salary": "",
    "source": "Anthropic",
    "url": "https://job-boards.greenhouse.io/anthropic/jobs/5157847008",
    "posted": "2026-04-08",
    "ageDays": 118,
    "tier": "D",
    "tags": [
      "TypeScript",
      "Python",
      "Rust",
      "AWS",
      "GCP",
      "Azure",
      "Kubernetes",
      "Claude Code",
      "Anthropic"
    ],
    "excerpt": "About Anthropic Anthropic’s mission is to create reliable, interpretable, and steerable AI systems. We want AI to be safe and beneficial for our users and for society as a whole. Our team is",
    "kw": "mỹ hoa kỳ nhóm d anthropic tại chỗ TypeScript Python Rust AWS GCP Azure Kubernetes Claude Code Anthropic"
  },
  {
    "id": "anth-5173031008",
    "company": "Anthropic",
    "position": "Manager of Applied AI Architecture, Partnerships",
    "location": "San Francisco, CA | New York City, NY | Seattle, WA",
    "remote": false,
    "salary": "",
    "source": "Anthropic",
    "url": "https://job-boards.greenhouse.io/anthropic/jobs/5173031008",
    "posted": "2026-04-01",
    "ageDays": 125,
    "tier": "D",
    "tags": [
      "Rust",
      "AWS",
      "GCP",
      "Azure",
      "Claude Code",
      "Anthropic"
    ],
    "excerpt": "About Anthropic Anthropic’s mission is to create reliable, interpretable, and steerable AI systems. We want AI to be safe and beneficial for our users and for society as a whole. Our team is",
    "kw": "mỹ hoa kỳ nhóm d anthropic tại chỗ Rust AWS GCP Azure Claude Code Anthropic"
  },
  {
    "id": "anth-5146298008",
    "company": "Anthropic",
    "position": "Staff Software Engineer, Billing Platform",
    "location": "San Francisco, CA | New York City, NY | Seattle, WA",
    "remote": false,
    "salary": "",
    "source": "Anthropic",
    "url": "https://job-boards.greenhouse.io/anthropic/jobs/5146298008",
    "posted": "2026-03-10",
    "ageDays": 147,
    "tier": "D",
    "tags": [
      "Rust",
      "AWS",
      "Claude Code",
      "Rails",
      "Anthropic"
    ],
    "excerpt": "About Anthropic Anthropic’s mission is to create reliable, interpretable, and steerable AI systems. We want AI to be safe and beneficial for our users and for society as a whole. Our team is",
    "kw": "mỹ hoa kỳ nhóm d anthropic tại chỗ Rust AWS Claude Code Rails Anthropic"
  },
  {
    "id": "anth-5140405008",
    "company": "Anthropic",
    "position": "Applied AI Architect, Government Technology",
    "location": "Washington, DC",
    "remote": false,
    "salary": "",
    "source": "Anthropic",
    "url": "https://job-boards.greenhouse.io/anthropic/jobs/5140405008",
    "posted": "2026-03-05",
    "ageDays": 152,
    "tier": "D",
    "tags": [
      "Python",
      "Rust",
      "AWS",
      "Claude Code",
      "Anthropic"
    ],
    "excerpt": "About Anthropic Anthropic’s mission is to create reliable, interpretable, and steerable AI systems. We want AI to be safe and beneficial for our users and for society as a whole. Our team is",
    "kw": "mỹ hoa kỳ nhóm d anthropic tại chỗ Python Rust AWS Claude Code Anthropic"
  },
  {
    "id": "anth-5140403008",
    "company": "Anthropic",
    "position": "Applied AI Architect, State and Local Government",
    "location": "New York City, NY; San Francisco, CA; Seattle, WA; Washington, DC",
    "remote": false,
    "salary": "",
    "source": "Anthropic",
    "url": "https://job-boards.greenhouse.io/anthropic/jobs/5140403008",
    "posted": "2026-03-05",
    "ageDays": 152,
    "tier": "D",
    "tags": [
      "Python",
      "Rust",
      "AWS",
      "Claude Code",
      "Anthropic"
    ],
    "excerpt": "About Anthropic Anthropic’s mission is to create reliable, interpretable, and steerable AI systems. We want AI to be safe and beneficial for our users and for society as a whole. Our team is",
    "kw": "mỹ hoa kỳ nhóm d anthropic tại chỗ Python Rust AWS Claude Code Anthropic"
  },
  {
    "id": "anth-5134895008",
    "company": "Anthropic",
    "position": "Senior Staff Software Engineer, API",
    "location": "San Francisco, CA | New York City, NY",
    "remote": false,
    "salary": "",
    "source": "Anthropic",
    "url": "https://job-boards.greenhouse.io/anthropic/jobs/5134895008",
    "posted": "2026-02-26",
    "ageDays": 159,
    "tier": "D",
    "tags": [
      "Python",
      "Rust",
      "Go",
      "PostgreSQL",
      "AWS",
      "GCP",
      "Azure",
      "Kubernetes",
      "Claude Code",
      "Anthropic"
    ],
    "excerpt": "About Anthropic Anthropic’s mission is to create reliable, interpretable, and steerable AI systems. We want AI to be safe and beneficial for our users and for society as a whole. Our team is",
    "kw": "mỹ hoa kỳ nhóm d anthropic tại chỗ Python Rust Go PostgreSQL AWS GCP Azure Kubernetes Claude Code Anthropic"
  },
  {
    "id": "anth-5125387008",
    "company": "Anthropic",
    "position": "Data Engineering Manager, Product",
    "location": "San Francisco, CA | New York City, NY | Seattle, WA",
    "remote": false,
    "salary": "",
    "source": "Anthropic",
    "url": "https://job-boards.greenhouse.io/anthropic/jobs/5125387008",
    "posted": "2026-02-19",
    "ageDays": 166,
    "tier": "D",
    "tags": [
      "Python",
      "Rust",
      "AWS",
      "Claude Code",
      "Anthropic"
    ],
    "excerpt": "About Anthropic Anthropic’s mission is to create reliable, interpretable, and steerable AI systems. We want AI to be safe and beneficial for our users and for society as a whole. Our team is",
    "kw": "mỹ hoa kỳ nhóm d anthropic tại chỗ Python Rust AWS Claude Code Anthropic"
  },
  {
    "id": "anth-5098025008",
    "company": "Anthropic",
    "position": "Model Performance Software Engineer, Claude Code",
    "location": "San Francisco, CA | New York City, NY",
    "remote": false,
    "salary": "",
    "source": "Anthropic",
    "url": "https://job-boards.greenhouse.io/anthropic/jobs/5098025008",
    "posted": "2026-02-02",
    "ageDays": 183,
    "tier": "D",
    "tags": [
      "TypeScript",
      "Python",
      "Rust",
      "AWS",
      "Claude Code",
      "Anthropic"
    ],
    "excerpt": "About Anthropic Anthropic’s mission is to create reliable, interpretable, and steerable AI systems. We want AI to be safe and beneficial for our users and for society as a whole. Our team is",
    "kw": "mỹ hoa kỳ nhóm d anthropic tại chỗ TypeScript Python Rust AWS Claude Code Anthropic"
  },
  {
    "id": "anth-5075093008",
    "company": "Anthropic",
    "position": "Strategic Account Executive, Cybersecurity",
    "location": "San Francisco, CA",
    "remote": false,
    "salary": "",
    "source": "Anthropic",
    "url": "https://job-boards.greenhouse.io/anthropic/jobs/5075093008",
    "posted": "2026-01-27",
    "ageDays": 189,
    "tier": "D",
    "tags": [
      "Rust",
      "AWS",
      "Claude Code",
      "Copilot",
      "Rails",
      "Anthropic"
    ],
    "excerpt": "About Anthropic Anthropic’s mission is to create reliable, interpretable, and steerable AI systems. We want AI to be safe and beneficial for our users and for society as a whole. Our team is",
    "kw": "mỹ hoa kỳ nhóm d anthropic tại chỗ Rust AWS Claude Code Copilot Rails Anthropic"
  },
  {
    "id": "anth-5096878008",
    "company": "Anthropic",
    "position": "Research Product Manager, Labs",
    "location": "San Francisco, CA | New York City, NY",
    "remote": false,
    "salary": "",
    "source": "Anthropic",
    "url": "https://job-boards.greenhouse.io/anthropic/jobs/5096878008",
    "posted": "2026-01-26",
    "ageDays": 190,
    "tier": "D",
    "tags": [
      "Rust",
      "AWS",
      "Claude Code",
      "Anthropic"
    ],
    "excerpt": "About Anthropic Anthropic’s mission is to create reliable, interpretable, and steerable AI systems. We want AI to be safe and beneficial for our users and for society as a whole. Our team is",
    "kw": "mỹ hoa kỳ nhóm d anthropic tại chỗ Rust AWS Claude Code Anthropic"
  },
  {
    "id": "anth-5079511008",
    "company": "Anthropic",
    "position": "Applied AI Architect, National Security",
    "location": "Washington, DC",
    "remote": false,
    "salary": "",
    "source": "Anthropic",
    "url": "https://job-boards.greenhouse.io/anthropic/jobs/5079511008",
    "posted": "2026-01-22",
    "ageDays": 194,
    "tier": "D",
    "tags": [
      "Python",
      "Rust",
      "AWS",
      "Claude Code",
      "Anthropic"
    ],
    "excerpt": "About Anthropic Anthropic’s mission is to create reliable, interpretable, and steerable AI systems. We want AI to be safe and beneficial for our users and for society as a whole. Our team is",
    "kw": "mỹ hoa kỳ nhóm d anthropic tại chỗ Python Rust AWS Claude Code Anthropic"
  },
  {
    "id": "anth-5074908008",
    "company": "Anthropic",
    "position": "Staff+ Software Engineer, Safeguards Infrastructure",
    "location": "London, UK",
    "remote": false,
    "salary": "",
    "source": "Anthropic",
    "url": "https://job-boards.greenhouse.io/anthropic/jobs/5074908008",
    "posted": "2026-01-21",
    "ageDays": 195,
    "tier": "D",
    "tags": [
      "TypeScript",
      "Python",
      "Rust",
      "AWS",
      "Claude Code",
      "Anthropic"
    ],
    "excerpt": "About Anthropic Anthropic’s mission is to create reliable, interpretable, and steerable AI systems. We want AI to be safe and beneficial for our users and for society as a whole. Our team is",
    "kw": "anh quốc nhóm d anthropic tại chỗ TypeScript Python Rust AWS Claude Code Anthropic"
  },
  {
    "id": "anth-4502508008",
    "company": "Anthropic",
    "position": "Staff+ Application Security Engineer",
    "location": "Remote-Friendly (Travel-Required) | San Francisco, CA | Seattle, WA | New York C",
    "remote": true,
    "salary": "",
    "source": "Anthropic",
    "url": "https://job-boards.greenhouse.io/anthropic/jobs/4502508008",
    "posted": "2025-01-22",
    "ageDays": 559,
    "tier": "D",
    "tags": [
      "TypeScript",
      "Python",
      "Rust",
      "AWS",
      "Claude Code",
      "Anthropic"
    ],
    "excerpt": "About Anthropic Anthropic’s mission is to create reliable, interpretable, and steerable AI systems. We want AI to be safe and beneficial for our users and for society as a whole. Our team is",
    "kw": "từ xa mỹ hoa kỳ nhóm d anthropic từ xa TypeScript Python Rust AWS Claude Code Anthropic"
  }
];
